import React, { useState } from 'react';
import ModalForm from '../../../components/ModalForm';
import { required, selectionRequired } from '../../../helpers/utils';
import { useData } from '../../../helpers/data-loader';
import Alert from '../../../helpers/alert';

interface ImportFormModalProps {
  agencyID: any;
  isOpenImportModal: boolean;
  toggleOpenImportModal: (val?: boolean) => void;
  fetchAgencyData?: () => void;
}

const ImportFormModal = ({
  agencyID,
  isOpenImportModal,
  toggleOpenImportModal,
}: ImportFormModalProps) => {
  const [file, setFile] = useState<any>();
  const [selectedType, setSelectedType] = useState('');

  const [, postImport] = useData('/admin/mass-import', {
    reqType: 'post',
  });

  const handleSubmitImport = async (values: any) => {
    const payload = new FormData();
    payload.append('file', file);
    payload.append('type', values.import_type);
    payload.append('agency_id', agencyID);

    await postImport(payload);
    const capitalizeMessage =
      values.import_type.charAt(0).toUpperCase() + values.import_type.slice(1);
    Alert.success(`${capitalizeMessage} import has queued.`);
    toggleOpenImportModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  const getImportDescription = (type: string) => {
    switch (type) {
      case 'granthub':
        return 'Import all data from a GrantHub export file. The file should contain sheets for Projects, Funders, Contacts, and Tasks.';
      case 'client':
        return 'Import clients from a single sheet Excel file.';
      case 'funder':
        return 'Import funders from a single sheet Excel file.';
      case 'project':
        return 'Import projects from a single sheet Excel file.';
      default:
        return '';
    }
  };

  const importModalField = [
    {
      name: 'import_type',
      label: 'Select import type',
      component: 'radio',
      choices: [
        {
          value: 'granthub',
          label: 'GrantHub Import (All Data)',
          disabled: false,
        },
        {
          value: 'client',
          label: 'Import Clients Only',
          disabled: false,
        },
        {
          value: 'funder',
          label: 'Import Funders Only',
          disabled: false,
        },
        {
          value: 'project',
          label: 'Import Projects Only',
          disabled: false,
        },
      ],
      validate: selectionRequired,
      onChange: (value) => setSelectedType(value),
    },
    {
      name: 'file',
      label: 'Select File',
      type: 'file',
      validate: required,
      fileOnChange: (val) => setFile(val),
      accept: '.xlsx',
    },
  ];

  return (
    <ModalForm
      title="Data Import"
      isOpen={isOpenImportModal}
      onSubmit={handleSubmitImport}
      onClose={toggleOpenImportModal}
      fields={importModalField}
      oneColumn
      buttonText="Import File"
    />
  );
};

export default ImportFormModal;
